import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { FormStateProvider } from './FormStateMachine';
import SignUp from './SignUp';
import Success from './Success';
import URLStateInitializer from './URLStateInitializer';

function App() {
  return (
    <FormStateProvider>
      <URLStateInitializer />
      <div className="App">
        <Routes>
          <Route path="/" element={<SignUp />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/payment" element={<SignUp />} />
          <Route path="/success" element={<Success />} />
          <Route 
            path="/signup/fairway" 
            element={<Navigate to="/signup?companyId=218d90e3-3f41-4000-b6ae-467edfc4e929" replace />} 
          />
          <Route 
            path="/signup/edge-home-finance" 
            element={<Navigate to="/signup?companyId=9037c833-17c2-43fe-aec3-ae4c43cecf6c" replace />} 
          />
          <Route 
            path="/signup/west-capital" 
            element={<Navigate to="/signup?companyId=65d85af7-bdce-485e-b60a-d290bf090807" replace />}
          />
          <Route
            path="/signup/union-home"
            element={<Navigate to="/signup?companyId=32b78cdb-ad7c-4a35-b2b4-b8a41cebf41e" replace />}
          />
          <Route
            path="/signup/rocket-mortgage"
            element={<Navigate to="/signup?companyId=b92d17aa-68dd-49c9-8097-583926507d62" replace />}
          />
          <Route
            path="/signup/barrett-financial"
            element={<Navigate to="/signup?companyId=bd5ca4d1-858d-4535-abb8-89e1164e0344" replace />}
          />
          <Route
            path="/signup/arbor-financial-group"
            element={<Navigate to="/signup?companyId=e1e7c655-735a-4b71-ad70-f1e1a7886967" replace />}
          />
          <Route
            path="/signup/c2-preferred-broker"
            element={<Navigate to="/signup?companyId=14b5e174-cb5d-4334-957e-e0f32e97a93a" replace />}
          />
          <Route
            path="/signup/xpert"
            element={<Navigate to="/signup?companyId=d37bbffd-2066-4f89-ac9d-adc63c2dba17" replace />}
          />
          <Route
            path="/signup/emortgage-capital"
            element={<Navigate to="/signup?companyId=42447d70-03ad-44e5-9999-161445d16f35" replace />}
          />
          <Route
            path="/signup/evergreen-home-loans"
            element={<Navigate to="/signup?companyId=a9d52fd4-5025-4747-8327-58c4e56b3149" replace />}
          />
          <Route
            path="/signup/vip-mortgage"
            element={<Navigate to="/signup?companyId=8421f384-df64-4ae0-941d-3e60f4ad88a0" replace />}
          />
          <Route
            path="/signup/all-western"
            element={<Navigate to="/signup?companyId=9fde629f-30ad-42a9-8133-8ad3b305fb7c" replace />}
          />
          <Route
            path="/signup/ccm"
            element={<Navigate to="/signup?companyId=16aa53d4-1862-4944-b250-dc33ca458f4a" replace />}
          />
          <Route
            path="/signup/revolution-mortgage"
            element={<Navigate to="/signup?companyId=814f099d-2604-48a2-8a26-dfd41d59ff19" replace />}
          />
          <Route
            path="/signup/umortgage"
            element={<Navigate to="/signup?companyId=158ed150-82fa-42f2-969c-7ef34b939ebd" replace />}
          />
          <Route
            path="/signup/newrez"
            element={<Navigate to="/signup?companyId=f6730666-cd94-4e1a-b300-de1e370ba15d" replace />}
          />
          <Route
            path="/signup/apm"
            element={<Navigate to="/signup?companyId=7c7eaa86-e792-469f-91ee-d9597719795c" replace />}
          />
          <Route
            path="/signup/fnf"
            element={<Navigate to="/signup?plan=fnf-agency-pro" replace />}
          />
          <Route
            path="/signup/wamp"
            element={<Navigate to="/signup?plan=wamp-preferred-broker-unlimited" replace />}
          />
        </Routes>
      </div>
    </FormStateProvider>
  );
}

export default App;
